






























































































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator'
import AppInfoLabelForm from '@core/components/AppInfoLabelForm.vue'
import { PERSONAL_DATA_STRUCTURE, FINANCIAL_DATA_STRUCTURE, PROPERTY_DATA_STRUCTURE } from './data/MyInfoDataStructure'
import { inject } from 'inversify-props'
import { IDateService } from '@master/services/IDateService'
import API from '@core/services/API'
import MyInfoLogo from '@core/assets/singpass_logo.png'
import CompanyLogoSvg from '@/assets/logo.png'
import { options } from '@master/model/options/Options'

interface MyInfo {
  key: string;
  label: string;
  value?: string;
  disabled?: boolean;
  isLockedField?: boolean;
  isNeedIncluded?: boolean;
  type?: string;
  mapWith?: options[];
}

@Component({
  components: {
    AppInfoLabelForm
  }
})
export default class TheMyInfoView extends Vue {
/* eslint-disable @typescript-eslint/camelcase */
  @Prop() readonly isFromClientSummary
  @Prop() readonly params
  @Prop({ default: false }) shouldRedirect: boolean

  private fetching = false
  private personalInfoList = []
  private financialInfoList = []
  private propertyInfoList = []
  private personalOid
  private confirmDialogVisible = false
  private rejectDialogVisible = false
  private alertDialogVisible = false
  private alertMsg = ''
  private systemDefaultLockedFields = []
  private userSelectedLockedFields = []
  private selectedPropIdx = -1
  private myInfoData = {}
  private myInfoPropData = []
  private myInfoIsValid = false
  private isCancel = false
  private isProceed = false

  @inject()
  private dateService: IDateService

  @inject()
  private $api: API

  get myInfoLogo () {
    return MyInfoLogo
  }

  get companyLogo () {
    return CompanyLogoSvg
  }

  async created () {
    console.log('created')
    await this.updateMyInfoData()
  }

  selectProperty (target) {
    if (this.selectedPropIdx === -1 || this.selectedPropIdx !== target) {
      this.selectedPropIdx = target
    } else if (this.selectedPropIdx === target) this.selectedPropIdx = -1
  }

  async updateMyInfoData () {
    if (this.isFromClientSummary) {
      // if it is accessed via kycform client summary button
      console.log('client summary')
      await this.fetchConfirmPersonInfo()
    } else {
      // if it is accessed via email link
      console.log('not client summary')
      this.personalOid = this.$route.query.personInfoOid
      await this.fetchUnconfirmPersonInfo(this.personalOid)
    }

    if (Object.keys(this.myInfoData).length) {
      this.personalInfoList = this.getPersonalInfoList(this.myInfoData)
      this.financialInfoList = this.getFinancialInfoList(this.myInfoData)
      this.propertyInfoList = this.getPropertyInfoList(this.myInfoPropData)
      // auto select first one
      if (this.propertyInfoList.length > 0) this.selectedPropIdx = 0
      this.myInfoIsValid = true
    }
  }

  async fetchConfirmPersonInfo () {
    try {
      this.fetching = true
      const response = await this.$api.myInfo.fetchComfirmedPersonInfo(this.params)
      if (response.property?.selected !== -1) this.selectedPropIdx = Number(response.property?.selected) ?? -1
      this.myInfoData = response.data
      if (response.property) { // Only if property exists, then get its data
        this.myInfoPropData = response.property.data
      }
      this.systemDefaultLockedFields = response.defaultLockedFields
      this.userSelectedLockedFields = response.lockedFields
    } catch (error) {
      console.error('TheMyInfoView: Exception', error)
      this.myInfoIsValid = false
      this.alertDialogVisible = true
      this.alertMsg = error
    } finally {
      this.fetching = false
    }
  }

  async fetchUnconfirmPersonInfo (oid) {
    try {
      this.fetching = true
      const response = await this.$api.myInfo.fetchUnconfirmPersonInfo({
        personInfoOid: oid
      })
      if (response.error || !response.data) {
        throw response.error || 'Data is unavailable'
      } else {
        this.myInfoData = response.data
        if (response.property) { // Only if property exists, then get its data
          this.myInfoPropData = response.property.data
        }
        this.systemDefaultLockedFields = response.defaultLockedFields
      }
    } catch (error) {
      console.error('TheMyInfoView: Exception', error)
      this.myInfoIsValid = false
      this.alertDialogVisible = true
      this.alertMsg = error
    } finally {
      this.fetching = false
    }
  }

  // isUserSelectedLockFieldElement (targetKey) {
  //   return this.userSelectedLockedFields.includes(targetKey)
  // }

  isSystemDefaultLockFieldElement (targetKey) {
    return this.systemDefaultLockedFields.includes(targetKey)
  }

  hasGroupElement (index) {
    return this.financialInfoList[index].group.some((ele: MyInfo) => {
      return ele.value
    })
  }

  getPersonalInfoList (info) {
    return PERSONAL_DATA_STRUCTURE.filter((ele) => {
      return info[ele.key] // to return element that have value in api return data
    }).map((ele: MyInfo) => {
      const isDefaultLockedField = this.isSystemDefaultLockFieldElement(ele.key)
      let value = ele.type === 'timeStamp' ? this.convertTimestamptoDateString(info[ele.key]) : info[ele.key]
      if (ele.mapWith) {
        const found = ele.mapWith.find(option => option.value === info[ele.key])
        if (found) { value = found.label }
      }
      const isNeedIncluded = value && value !== '-'
      return {
        isLockedField: isDefaultLockedField,
        isNeedIncluded: isNeedIncluded,
        value: value,
        lockSwitch: isDefaultLockedField,
        disabled: isDefaultLockedField,
        ...ele
      }
    })
  }

  getFinancialInfoList (info) {
    return FINANCIAL_DATA_STRUCTURE.filter((ele) => {
      return ele.group.filter((group) => {
        return info[group.key]
      }).map((newObj: MyInfo) => {
        const isDefaultLockedField = this.isSystemDefaultLockFieldElement(newObj.key)
        const value = newObj.type === 'timeStamp' ? this.convertTimestamptoDateString(info[newObj.key]) : info[newObj.key]
        const isNeedIncluded = value && value !== '-'
        return Object.assign(newObj, { // to add additional key to the element
          isLockedField: isDefaultLockedField,
          isNeedIncluded: isNeedIncluded,
          value: value,
          lockSwitch: isDefaultLockedField,
          disabled: isDefaultLockedField || value === '-'
        })
      }).length > 0
    })
  }

  getPropertyInfoList (props) {
    if (!props) return []
    return props.map((property) => {
      const display = { isSelected: false, fields: [] }
      const attrs = Object.keys(property)
      display.fields = attrs.map((attr) => {
        const config = PROPERTY_DATA_STRUCTURE.find(ds => ds.key === attr)
        const isDefaultLockedField = this.isSystemDefaultLockFieldElement(config.key)
        const value = config.type === 'timeStamp' ? this.convertTimestamptoDateString(property[config.key]) : property[config.key]
        return {
          isLockedField: isDefaultLockedField,
          isNeedIncluded: isDefaultLockedField,
          value: value,
          disabled: true,
          ...config
        }
      })
      return display
    })
  }

  convertTimestamptoDateString (timeStamp) {
    const readableDate = this.dateService.format(Number(timeStamp), 'DD/MM/YYYY')
    // timeStamp can be `-` after backend processing
    return readableDate === 'Invalid Date' ? timeStamp : readableDate
  }

  proceed () {
    this.confirmDialogVisible = false
    if (this.isFromClientSummary) {
      this.linkPersonInfo(true)
    } else {
      this.postClientConfirmDecision()
    }
  }

  cancel () {
    this.rejectDialogVisible = false
    if (this.isFromClientSummary) {
      this.linkPersonInfo(false)
    } else {
      this.postClientRejectDecision()
    }
  }

  @Emit('link-person-info')
  linkPersonInfo (linked) {
    return {
      shouldLinked: linked,
      clientIndex: this.params.clientIndex,
      propertyIdx: this.selectedPropIdx,
      lockedField: this.getUserSelectedLockField()
    }
  }

  postClientRejectDecision () {
    try {
      this.$api.myInfo.postClientDecision({
        personInfoOid: this.personalOid,
        clientDecision: false,
        lockedFields: []
      })
      this.alertMsg = 'Cancel Link Singpass Success'
    } catch (error) {
      console.error('error in postClientDecision ', error)
      this.alertMsg = error
    } finally {
      this.alertDialogVisible = true
      this.isCancel = true
    }
  }

  getUserSelectedLockField () {
    const lockedPersonalInfo = this.getLockedField(this.personalInfoList)
    const lockedFinancialInfo = this.getFinancialLockedField(this.financialInfoList)

    return lockedPersonalInfo.concat(lockedFinancialInfo)
  }

  async postClientConfirmDecision () {
    try {
      const result = await this.$api.myInfo.postClientDecision({
        personInfoOid: this.personalOid,
        clientDecision: true,
        propertyIdx: this.selectedPropIdx,
        lockedFields: JSON.stringify(this.getUserSelectedLockField())
      })
      this.alertMsg = 'Success'
      this.isProceed = true

      if (result.personInfo?.kycform_oid && this.shouldRedirect) {
        this.$router.push({ path: '/kyc-form/' + result.personInfo?.kycform_oid })
      }
    } catch (error) {
      console.error('error in postClientDecision ', error)
      this.alertMsg = error
    } finally {
      this.alertDialogVisible = true
    }
  }

  getLockedField (list) {
    return list.filter(ele => {
      return ele.isNeedIncluded
    }).map(ele => {
      return ele.key
    })
  }

  getFinancialLockedField (list) {
    let lockList = []
    list.forEach(ele => {
      const x = ele.group.filter(groupEle => {
        return groupEle.isNeedIncluded
      }).map(groupEle => {
        return groupEle.key
      })
      lockList = lockList.concat(x)
    })
    return lockList
  }

  // when we close the dialog (via link singpass button), it didnt rerender this component
  // old data is display instead of the new data
  // (exp: if client 2 is open before client 1, then client 2 data is displayed although is client 1 trigger this component)
  // therefore add a watcher to the param Input to make sure the input fields is updated
  @Watch('params')
  async paramsOnChange () {
    await this.updateMyInfoData()
  }
}
